import { TimeReport, TimeReportProjectItem } from "../types";
import { isSameTimeReportProjectItem } from "./isSameTimeReportProjectItem";
import { TimeReportProjectItemPath } from "./TimeReportProjectItemPath";

export type TransformTimeReportProjectItemFunction = (item: TimeReportProjectItem) => TimeReportProjectItem;

export const transformTimeReportProjectItem = (
  timeReport: TimeReport,
  path: TimeReportProjectItemPath,
  transform: TransformTimeReportProjectItemFunction,
): TimeReport => {
  const { projectGuid, payCodeGuid, date } = path;

  const projectIdx = timeReport.projects.findIndex(pr => pr.project.guid === projectGuid);

  if (projectIdx >= 0) {
    const compareItem = isSameTimeReportProjectItem(payCodeGuid, date);
    const project = timeReport.projects[projectIdx];
    const itemIdx = project.items.findIndex(compareItem);

    if (itemIdx >= 0) {
      const newProject = {
        ...project,
        items: project.items.map((currentItem, idx) => (idx === itemIdx ? transform(currentItem) : currentItem)),
      };

      return {
        ...timeReport,
        projects: timeReport.projects.map((currentProject, idx) => (idx === projectIdx ? newProject : currentProject)),
      };
    }
  }

  return { ...timeReport };
};
